import { render, staticRenderFns } from "./PageBuyerDashboard.vue?vue&type=template&id=2f5481bb&"
import script from "./PageBuyerDashboard.vue?vue&type=script&lang=js&"
export * from "./PageBuyerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports